import { render } from "./ProjectModal.vue?vue&type=template&id=caa26578"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__